import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg bg-background-50 border border-background-200 transition-all hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 抢先看与更新进度`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-foreground-950">
          <i className="ri-star-fill text-xs"></i>
          {comic.rating}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950">{comic.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{comic.latestChapter}</p>
        <div className="mt-3 space-y-1.5">
          <div className="flex items-center justify-between text-[11px]">
            <span className="flex items-center gap-1 text-foreground-600">
              <i className="ri-refresh-line text-secondary-600"></i>更新进度
            </span>
            <span className="font-bold text-secondary-700">{comic.updateProgress}%</span>
          </div>
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
            <div
              className="h-full rounded-full bg-secondary-500"
              style={{ width: `${comic.updateProgress}%` }}
            ></div>
          </div>
          <div className="flex items-center justify-between pt-1 text-[11px]">
            <span className="flex items-center gap-1 text-foreground-600">
              <i className="ri-translate-2 text-primary-500"></i>汉化进度
            </span>
            <span className="font-bold text-primary-700">{comic.translateProgress}%</span>
          </div>
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
            <div
              className="h-full rounded-full bg-primary-500"
              style={{ width: `${comic.translateProgress}%` }}
            ></div>
          </div>
        </div>
      </div>
    </Link>
  );
}